import React from 'react'

import Base from '../../_Base'

const YouTube16 = (props) => (
  <Base
    aria-hidden="true"
    focusable="false"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      d="M15.666 4.124A2.01 2.01 0 0 0 14.251 2.7 47.511 47.511 0 0 0 8 2.364a47.511 47.511 0 0 0-6.251.336A2.01 2.01 0 0 0 .334 4.124 21.09 21.09 0 0 0 0 8a21.09 21.09 0 0 0 .334 3.876A2.01 2.01 0 0 0 1.749 13.3c2.074.25 4.162.362 6.251.336a47.509 47.509 0 0 0 6.251-.337 2.01 2.01 0 0 0 1.415-1.424A21.09 21.09 0 0 0 16 8a21.09 21.09 0 0 0-.334-3.876zm-9.3 6.255V5.621L10.545 8l-4.179 2.379z"
      fillRule="evenodd"
    />
  </Base>
)

export default YouTube16
